/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { PopoverButton, PopoverPanel, Popover as HeadlessPopover } from '@headlessui/react'
import { ReactNode } from 'react'

type PopoverProps = {
  button: ReactNode
  children: ReactNode
  position?: 'top' | 'bottom' | 'left' | 'right'
  panelClassName?: string
  buttonClassName?: string
}

const Popover = ({
  button,
  children,
  position = 'bottom',
  panelClassName = '',
  buttonClassName = ''
}: PopoverProps) => {
  // Позиционирование панели
  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full mb-2'
      case 'bottom':
        return 'top-full mt-2'
      case 'left':
        return 'right-full mr-2'
      case 'right':
        return 'left-full ml-2'
      default:
        return 'top-full mt-2'
    }
  }

  return (
    <HeadlessPopover className="relative">
        {/* @ts-ignore */}
      {({ open }) => (
        <>
          <PopoverButton
            as="div"
            className={`focus:outline-none ${buttonClassName}`}
          >
            {button}
          </PopoverButton>

          <PopoverPanel
            className={`absolute z-10 ${getPositionClasses()} ${panelClassName}`}
          >
            <div className="bg-white rounded-lg shadow-lg ring-1 ring-black/5">
              {children}
            </div>
          </PopoverPanel>
        </>
      )}
    </HeadlessPopover>
  )
}

export default Popover;